import { AnimatePresence, motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';

export const AnimatedWrapper = AnimatePresence;

interface AnimatedItemProps {
  delay?: number;
  duration?: number;
  layout?: boolean;
}

export const AnimatedItem: FC<PropsWithChildren<AnimatedItemProps>> = ({
  children,
  delay,
  duration = 0.3,
  ...rest
}) => {
  return (
    <motion.div
      transition={{ duration, delay }}
      initial={{ opacity: 0, x: 0, scale: 0.5, transform: 'none' }}
      animate={{ opacity: 1, x: 0, scale: 1, transform: 'none' }}
      exit={{ opacity: 0, x: 0, scale: 0.5, transform: 'none' }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
